"use strict";

/** @todo Возможно, стоит оставить в lingo2-account */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingTaskStatusEnum = exports.BillingTaskPriorityEnum = exports.BillingTaskEnum = void 0;
/** Тип задания BillingTask.task */
var BillingTaskEnum;
(function (BillingTaskEnum) {
  BillingTaskEnum[BillingTaskEnum["paid_meeting_deposit"] = 1] = "paid_meeting_deposit";
  BillingTaskEnum[BillingTaskEnum["paid_meeting_deposit_undo"] = 3] = "paid_meeting_deposit_undo";
  BillingTaskEnum[BillingTaskEnum["purchase_meeting"] = 2] = "purchase_meeting";
  BillingTaskEnum[BillingTaskEnum["cancel_meeting_fine"] = 4] = "cancel_meeting_fine";
})(BillingTaskEnum = exports.BillingTaskEnum || (exports.BillingTaskEnum = {}));
/** Приоритет задания BillingTask.priority */
var BillingTaskPriorityEnum;
(function (BillingTaskPriorityEnum) {
  BillingTaskPriorityEnum[BillingTaskPriorityEnum["lowest"] = 0] = "lowest";
  BillingTaskPriorityEnum[BillingTaskPriorityEnum["low"] = 10] = "low";
  BillingTaskPriorityEnum[BillingTaskPriorityEnum["normal"] = 20] = "normal";
  BillingTaskPriorityEnum[BillingTaskPriorityEnum["high"] = 30] = "high";
  BillingTaskPriorityEnum[BillingTaskPriorityEnum["highest"] = 40] = "highest";
})(BillingTaskPriorityEnum = exports.BillingTaskPriorityEnum || (exports.BillingTaskPriorityEnum = {}));
/** Статус задания BillingTask.status */
var BillingTaskStatusEnum;
(function (BillingTaskStatusEnum) {
  /** ожидает */
  BillingTaskStatusEnum[BillingTaskStatusEnum["pending"] = 3] = "pending";
  /** исполняется */
  BillingTaskStatusEnum[BillingTaskStatusEnum["processing"] = 4] = "processing";
  /** завершена успешно */
  BillingTaskStatusEnum[BillingTaskStatusEnum["succeed"] = 5] = "succeed";
  /** отменена */
  BillingTaskStatusEnum[BillingTaskStatusEnum["canceled"] = 6] = "canceled";
  /** завершилась с ошибкой */
  BillingTaskStatusEnum[BillingTaskStatusEnum["failed"] = 7] = "failed";
})(BillingTaskStatusEnum = exports.BillingTaskStatusEnum || (exports.BillingTaskStatusEnum = {}));
